import { render, staticRenderFns } from "./location.vue?vue&type=template&id=39f6a6cb&scoped=true&"
import script from "./location.vue?vue&type=script&lang=js&"
export * from "./location.vue?vue&type=script&lang=js&"
import style0 from "./location.vue?vue&type=style&index=0&id=39f6a6cb&scoped=true&lang=css&"
import style1 from "./location.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f6a6cb",
  null
  
)

export default component.exports